import type { RawRegulationsFormValues, RawRegulationsType } from './RawRegulations.types.ts';
import type { GeneralRegulationType } from '../../types/regulation.ts';

export const normalize = (data: GeneralRegulationType) => ({
  id: data?.id || null,
  author: data?.author
    ? [
        {
          value: data?.author?.entraId || '',
          label: data?.author?.displayName || '',
          key: data?.author?.email || '',
        },
      ]
    : [],
  topics: data?.topics?.map((topic: { id: string }) => topic.id) || [],
  targetGroupId: data?.targetGroup?.id || null,
  unitInChargeId: data?.unitInCharge?.id || null,
  regulationNumber: data?.regulationNumber || '',
  title: data?.title || '',
  titleEnglish: data?.titleEnglish || '',
  isActive: data?.isActive,
  isDeleted: data?.isDeleted,
  type: data?.type || null,
  emergedOut: data?.emergedOut || '',
  confirmationPeriod: data?.confirmationPeriod || null,
  shortDescription: data?.shortDescription || '',
  shortDescriptionEnglish: data?.shortDescriptionEnglish || '',
  content: data?.content || '',
  creationDate: data?.creationDate || '',
  publicationDate: data?.publicationDate || '',
  deletionDate: data?.deletionDate || '',
  confirmationDate: data?.confirmationDate || '',
  attachments: data?.attachments || [],
});

export const getRawRegulationValues = (data: RawRegulationsType) => ({
  id: data?.id || null,
  title: data?.title || '',
  titleEnglish: data?.titleEnglish || '',
  isActive: data?.isActive,
  author: data?.author || [],
  type: data?.type || null,
  emergedOut: data?.emergedOut || '',
  confirmationPeriod: data?.confirmationPeriod || null,
  unitInChargeId: data?.unitInChargeId || null,
  topics: data?.topics || [],
  targetGroupId: data?.targetGroupId || null,
  shortDescription: data?.shortDescription || '',
  shortDescriptionEnglish: data?.shortDescriptionEnglish || '',
  content: data?.content || '',
});

export const getRawRegulationData = (values: RawRegulationsFormValues) => ({
  id: values.id,
  title: values.title,
  titleEnglish: values.titleEnglish,
  author: {
    entraId: values?.author?.[0]?.value ?? '',
    displayName: values?.author?.[0]?.label ?? '',
    email: values?.author?.[0]?.key ?? '',
  },
  unitInChargeId: values.unitInChargeId,
  confirmationPeriod: values.confirmationPeriod,
  emergedOut: values.emergedOut,
  topics: values.topics,
  type: values.type,
  targetGroupId: values.targetGroupId,
});